/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Downloads_DescriptionInputs */

const id_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh versi terbaru. Kami telah menyoroti bagian yang direkomendasikan untuk sistem operasi Anda.`)
};

const ms_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat turun versi terkini. Kami telah menyerlahkan bahagian yang disyorkan untuk sistem pengendalian anda.`)
};

const da_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download den seneste version. Vi har fremhævet den anbefalede sektion til dit operativsystem.`)
};

const de_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden Sie die neueste Version herunter. Wir haben den empfohlenen Bereich für Ihr Betriebssystem hervorgehoben.`)
};

const en_us2_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the latest version. We've highlighted the recommended section for your operating system.`)
};

const es_es2_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga la última versión. Hemos resaltado la sección recomendada para tu sistema operativo.`)
};

const es_mx2_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga la última versión. Hemos resaltado la sección recomendada para tu sistema operativo.`)
};

const fil_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-download ang pinakabagong bersyon. Na-highlight namin ang inirerekomendang seksyon para sa iyong operating system.`)
};

const fr_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargez la dernière version. Nous avons mis en évidence la section recommandée pour votre système d'exploitation.`)
};

const it_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica l'ultima versione. Abbiamo evidenziato la sezione consigliata per il tuo sistema operativo.`)
};

const hu_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Töltse le a legújabb verziót. Kiemeltük az operációs rendszeréhez ajánlott szakaszt.`)
};

const nl_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download de nieuwste versie. We hebben de aanbevolen sectie voor uw besturingssysteem gemarkeerd.`)
};

const no_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last ned den nyeste versjonen. Vi har fremhevet den anbefalte delen for operativsystemet ditt.`)
};

const pl_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz najnowszą wersję. Wyróżniliśmy zalecaną sekcję dla Twojego systemu operacyjnego.`)
};

const pt_br2_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixe a versão mais recente. Destacamos a seção recomendada para o seu sistema operacional.`)
};

const pt_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregue a versão mais recente. Destacámos a secção recomendada para o seu sistema operativo.`)
};

const ro_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarcă cea mai recentă versiune. Am evidențiat secțiunea recomandată pentru sistemul tău de operare.`)
};

const fi_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa uusin versio. Olemme korostaneet suositeltua osiota käyttöjärjestelmällesi.`)
};

const sv_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda ner den senaste versionen. Vi har markerat den rekommenderade sektionen för ditt operativsystem.`)
};

const vi_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải xuống phiên bản mới nhất. Chúng tôi đã làm nổi bật phần được đề xuất cho hệ điều hành của bạn.`)
};

const tr_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En son sürümü indirin. İşletim sisteminiz için önerilen bölümü vurguladık.`)
};

const cs_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhněte si nejnovější verzi. Zvýraznili jsme doporučenou sekci pro váš operační systém.`)
};

const bg_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтеглете най-новата версия. Маркирахме препоръчителния раздел за вашата операционна система.`)
};

const ru_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачайте последнюю версию. Мы выделили рекомендуемый раздел для вашей операционной системы.`)
};

const uk_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажте останню версію. Ми виділили рекомендований розділ для вашої операційної системи.`)
};

const ar_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم بتنزيل أحدث إصدار. لقد سلطنا الضوء على القسم الموصى به لنظام التشغيل الخاص بك.`)
};

const hi_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नवीनतम संस्करण डाउनलोड करें।`)
};

const th_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดาวน์โหลดเวอร์ชันล่าสุด เราได้เน้นส่วนที่แนะนำสำหรับระบบปฏิบัติการของคุณ`)
};

const ja_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新バージョンをダウンロード。お使いのOSに最適なセクションをハイライトしています。`)
};

const zh_cn2_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载最新版本。我们已为你的操作系统突出显示推荐选项。`)
};

const zh_hant1_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下載最新版本。我們已為你的作業系統突顯顯示推薦選項。`)
};

const ko_misc_downloads_description = /** @type {(inputs: Misc_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최신 버전을 다운로드하세요. 운영 체제에 맞는 권장 항목이 강조 표시되어 있습니다.`)
};

/**
* | output |
* | --- |
* | "Download the latest version. We've highlighted the recommended section for your operating system." |
*
* @param {Misc_Downloads_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_description = /** @type {((inputs?: Misc_Downloads_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_description(inputs)
	if (locale === "ms") return ms_misc_downloads_description(inputs)
	if (locale === "da") return da_misc_downloads_description(inputs)
	if (locale === "de") return de_misc_downloads_description(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_description(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_description(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_description(inputs)
	if (locale === "fil") return fil_misc_downloads_description(inputs)
	if (locale === "fr") return fr_misc_downloads_description(inputs)
	if (locale === "it") return it_misc_downloads_description(inputs)
	if (locale === "hu") return hu_misc_downloads_description(inputs)
	if (locale === "nl") return nl_misc_downloads_description(inputs)
	if (locale === "no") return no_misc_downloads_description(inputs)
	if (locale === "pl") return pl_misc_downloads_description(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_description(inputs)
	if (locale === "pt") return pt_misc_downloads_description(inputs)
	if (locale === "ro") return ro_misc_downloads_description(inputs)
	if (locale === "fi") return fi_misc_downloads_description(inputs)
	if (locale === "sv") return sv_misc_downloads_description(inputs)
	if (locale === "vi") return vi_misc_downloads_description(inputs)
	if (locale === "tr") return tr_misc_downloads_description(inputs)
	if (locale === "cs") return cs_misc_downloads_description(inputs)
	if (locale === "bg") return bg_misc_downloads_description(inputs)
	if (locale === "ru") return ru_misc_downloads_description(inputs)
	if (locale === "uk") return uk_misc_downloads_description(inputs)
	if (locale === "ar") return ar_misc_downloads_description(inputs)
	if (locale === "hi") return hi_misc_downloads_description(inputs)
	if (locale === "th") return th_misc_downloads_description(inputs)
	if (locale === "ja") return ja_misc_downloads_description(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_description(inputs)
	return ko_misc_downloads_description(inputs)
});
export { misc_downloads_description as "misc.downloads.description" }